var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ height: _vm.contentHeight }),attrs:{"name":"modulePreview"}},[_c('module-preview',{staticStyle:{"height":"100%"},attrs:{"data":_vm.moduleData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }